import {portalApiPost} from '@/lib/portal-api';
export type ConsultationAction =
  | {readonly action:'record_fee';readonly billId:number}
  | {readonly action:'waive_fee'|'reverse_waiver';readonly billId:number;readonly reason:string}
  | {readonly action:'complete_course';readonly courseId:number}
  | {readonly action:'abandon_course';readonly courseId:number;readonly reason:string};
/** Existing authenticated transport. No authority, amount or actor fields. */
export function submitConsultationAction(appointmentId:number, action:ConsultationAction):Promise<unknown>{
  return portalApiPost(`/appointments/${appointmentId}/consultation-actions`,action);
}
